/* eslint-disable */
export default {
  to: 'Para:',
  enterNameOrPhoneNumber: 'Inserir número',
} as const;

// @key: @#@"to"@#@ @source: @#@"To:"@#@
// @key: @#@"enterNameOrPhoneNumber"@#@ @source: @#@"Enter Number"@#@
